import { FlexContainer, Subtitle, Title } from '@emarketer/componentlibrary';
import styled from 'styled-components';

export const LabeledRadioButtonContainer = styled(FlexContainer)``;

export const LabeledRadioButtonWrapper = styled.div``;

export const LabeledRadioButtonLabelWrapper = styled.div``;

export const LabeledRadioButtonLabel = styled(Title)`
  cursor: pointer;
`;

export const LabeledRadioButtonSublabel = styled(Subtitle)`
  color: #a4a4a4;
`;
